export const DEFAULT_COLOR = "#1E3A5F";
export const ACTIVE_COLOR = "#4D6D95";
export const YELLOW_COLOR = "#f29230";
